import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'
import service1 from '../img/services/service.jpg';
// import service2 from '../img/services/service2.jpg';
// import service3 from '../img/services/service3.jpg';
import project1 from '../img/background/project1.png';
import service4  from '../img/background/pipe.png';
import service2  from '../img/background/design.png';
// import service3  from '../img/background/ductwork.jpg';
import service3  from '../img/background/duct.png';
import service5  from '../img/background/projectmanagement.jpg';
import service7  from '../img/background/construction.jpg';
import service6  from '../img/background/const.png';
import profile from '../img/background/Tracs_profile.pdf';

export default function Services() {


const servicesContent = {
  "Design & Engineering": {
    title: "Design & Engineering",
    image: service2,
    description: "Fully in-house mechanical design and engineering team, custom HVAC system designs for commercial, residential, and industrial sectors, 3D drafting and BIM coordination to integrate with modern construction methods.",
    additionalText: "Our in-house team provides end-to-end mechanical design and engineering services for a range of sectors."
  },
   "Design & Engineering2": {
    title: "Design & Engineering",
    image: service2,
    description: "Fully in-house mechanical design and engineering team, custom HVAC system designs for commercial, residential, and industrial sectors, 3D drafting and BIM coordination to integrate with modern construction methods.",
    additionalText: "Our in-house team provides end-to-end mechanical design and engineering services for a range of sectors."
  },
  "Ductwork Installation": {
    title: "Ductwork Installation",
    image: service3,
    description: "Full-service sheet metal duct fabrication and installation, expertise in complex duct routing for high-spec architectural projects, high standards of air sealing and acoustic performance.",
    additionalText: "We ensure that all ductwork installations meet high-quality standards, focusing on performance and noise reduction."
  },
  "Pipework Installation": {
    title: "Pipework Installation",
    image: service4,
    description: "Installation of chilled water, condenser water, and refrigerant pipe systems, skilled technicians with extensive experience in mechanical piping, compliance with all relevant Australian standards and codes.",
    additionalText: "Our team specializes in the installation of pipe systems that are essential for HVAC and mechanical projects. We ensure compliance with all industry standards."
  },
  "Project Management & Construction": {
    title: "Project Management & Construction",
    image: service5,
    description: "End-to-end project management services from design through to handover, specialization in multi-storey and architecturally complex builds, proven delivery track record in remote mining and industrial locations.",
    additionalText: "We manage every phase of your project, ensuring timely and efficient completion."
  },
  "HVAC Maintenance & Servicing": {
    title: "HVAC Maintenance & Servicing",
    image: service6,
    description: "Dedicated maintenance division for ongoing support, preventative maintenance programs tailored to client needs, rapid response teams for breakdowns and emergency service.",
    additionalText: "We offer comprehensive HVAC maintenance to keep systems running smoothly and reduce the risk of breakdowns."
  }
};


   const [selectedService, setSelectedService] = useState("Design & Engineering");

  // const handleMenuClick = (service) => {alert(service)
  //   setSelectedService(service);
  // };

  function handleMenuClick(service){
    
    setSelectedService(service);
  }

  const { title, image, description, additionalText } = servicesContent[selectedService];




  return (
    <div>
        <Header />

            <div className="page_title servicepage">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        
        <h5 className="page_tittle activeColor text-center text-uppercase">
         Services
        </h5>
     
      </div>
    </div>
  </div>
</div>



    <div className="service-details-pages">
      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-md-12 col-lg-5 col-xl-4 order-1 order-lg-0 mt-2 mt-lg-0">
            <div id="tab-list-block">
              <div className="market-list-group">
               
                  <ul >
        <li><a className={selectedService === "Design & Engineering" ? "active" : ""}  onClick={() => handleMenuClick("Design & Engineering")}></a></li>
        </ul>
                 
                  <p><a className={selectedService === "Design & Engineering" ? "active" : ""}  onClick={() => handleMenuClick("Design & Engineering")}>Design & Engineering</a></p>
        <p><a className={selectedService === "Ductwork Installation" ? "active" : ""}  onClick={() => handleMenuClick("Ductwork Installation")}>Ductwork Installation</a></p>
        <p><a className={selectedService === "Pipework Installation" ? "active" : ""}  onClick={() => handleMenuClick("Pipework Installation")}>Pipework Installation</a></p>
        <p><a className={selectedService === "Project Management & Construction" ? "active" : ""}  onClick={() => handleMenuClick("Project Management & Construction")}>Project Management & Construction</a></p>
        <p><a className={selectedService === "HVAC Maintenance & Servicing" ? "active" : ""}  onClick={() => handleMenuClick("HVAC Maintenance & Servicing")}>HVAC Maintenance & Servicing</a></p>
     
                
              </div>
            </div>

            {/* Brochures */}
            <div id="brochures-block">
              <div className="list-group mt-3 mb-3 mt-lg-5 mb-lg-5 d-flex">
                <a
                  className="list-group-item list-group-item-action download-brochures d-flex justify-content-between"
                  target="_blank" href={profile}
                >
                  Download Profile<i className='fa fa-download download-icon'></i>
                 
                </a>
              </div>
            </div>

            {/* Contact Our Team */}
            <div
              className="block wow fadeInUp animated"
              data-wow-delay="100ms"
              data-wow-duration="1200ms"
            >
              <div className="contact-service">
                <h3>Contact Our Team</h3>
                <p>
                  Please feel free to contact us. We will get back to you within
                  1-2 business days. Or just call us now.
                </p>
                <p>
                  <span className="font-weight-bold">
                    <i className="fa fa-phone fw-size" aria-hidden="true"></i> CALL US:
                  </span>{" "}
                 +61 08 9353 4544
                </p>
                <p className="mb-0">
                  <span className="font-weight-bold">
                    <i className="fa fa-envelope-o fw-size" aria-hidden="true"></i> MAIL US:
                  </span>{" "}
                  tracs@tracs.com.au
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="col-md-12 col-lg-7 col-xl-8 order-0 order-lg-1">
            <div className="market-content-page">
              <div className="block">
                <div className="text-img-block">
                  <img className="img-fluid" src={image} alt="service top" />
                  <h3 className="services-right-title">{title}</h3>
                  <p>
                    {description}
                  </p>
                  <p>
                   {additionalText}
                  </p>
                </div>

                {/* Why Choose Us */}
               
              

                {/* Research & Development */}
             <div className="row border-top pt-lg-4">
  <div className="col-md-5 col-lg-12 col-xl-6 pl-lg-0">
    <img className="img-fluid" src={service1} alt="service bottom" />
  </div>
  <div className="col-md-7 col-lg-12 col-xl-6 mt-3 mt-md-0 mt-lg-3 mt-xl-0 pl-lg-0">
    <div>
      <h6 className="sub-title mb-1">Research & Development</h6>
    </div>
    <p>
      At TRACS, innovation drives everything we do. Our in-house engineering
      and design teams continuously develop smarter, more efficient HVAC
      solutions that adapt to the evolving needs of commercial, industrial,
      and residential environments.
    </p>
    <div className="list_content">
      <p className="mb-2">
        <i className="fa fa-check mr-1 mr-lg-3 activeColor" aria-hidden="true"></i>
        Integration of 3D drafting and BIM technologies for precision and
        seamless project delivery.
      </p>
      <p className="mb-2">
        <i className="fa fa-check mr-1 mr-lg-3 activeColor" aria-hidden="true"></i>
        Development of energy-efficient HVAC designs that reduce costs and
        environmental impact.
      </p>
      <p className="mb-2">
        <i className="fa fa-check mr-1 mr-lg-3 activeColor" aria-hidden="true"></i>
        Continuous improvement of maintenance programs and rapid-response
        service models.
      </p>
    </div>
  </div>
</div>


              </div>
            </div>
          </div>
          {/* End Main Content */}
        </div>
      </div>
    </div>
 

        <Footer />

    </div>
  )
}
